import { useContext } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button, useToast } from '@chakra-ui/react';

import { apiUpdateCallListItem } from 'api';

import type { APICallListData } from 'types/api.types';

import { AuthContext } from 'contexts/AuthContext';

const ItemAssign = ({
  item,
  queryKey,
  onAction,
}: {
  item: APICallListData;
  queryKey: unknown[];
  onAction?: () => void;
}) => {
  const { user } = useContext(AuthContext);
  const toast = useToast();
  const queryClient = useQueryClient();

  const assignMutation = useMutation({
    mutationFn: () => {
      return apiUpdateCallListItem(item.id, { user: user.id });
    },
    onSuccess: (data) => {
      queryClient.setQueryData(queryKey, (oldData: any) => {
        if (!oldData) return oldData;

        return {
          ...oldData,
          results: oldData.results.map((item: APICallListData) =>
            item.id === data.id ? data : item,
          ),
        };
      });

      toast({
        title: 'Item assigned successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top',
      });

      if (onAction) {
        onAction();
      }
    },
    onError: (error: any) => {
      let errorMessage = 'Unknown error occurred';

      if (error?.user) {
        errorMessage = error.user[0];

        queryClient.setQueryData(queryKey, (oldData: any) => {
          if (!oldData) return oldData;

          return {
            ...oldData,
            results: oldData.results.filter(
              (cahceItem: APICallListData) => cahceItem.id !== item.id,
            ),
          };
        });
      }

      toast({
        title: 'Error assigning item',
        description: errorMessage,
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    },
  });

  return (
    <Button
      colorScheme="yellow"
      onClick={() => assignMutation.mutate()}
      isLoading={assignMutation.isPending}
      loadingText="Assigning..."
      w="100%"
      size="sm"
    >
      Assign to me
    </Button>
  );
};

export default ItemAssign;
